import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';
import { SnackbarService } from '../snackbar.service';

/**
 * Intercept
 *
 * @param req
 * @param next
 */
export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const snackbarService = inject(SnackbarService);
    // Clone the request object
    let newReq = req.clone();

    // Response
    return next(newReq)
        .pipe(
            catchError((error) => {
                // Catch "401 Unauthorized" responses
                if (error instanceof HttpErrorResponse && error.status === 401) {

                    return throwError(() => error);
                }
                else {

                    let errorMessage = 'An unexpected error occurred: ';

                    if (error.error?.errors) {
                        Object.keys(error.error.errors).forEach(field => {
                            errorMessage = errorMessage + ` ${error.error.errors[field].join(', ')}`;
                        });
                    }
                    snackbarService.showError(errorMessage);
                }
                return throwError(() => error);
            })
        );
};